/**
 * index
 */
export * from './src/index';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-splitbuttons/index.js
// module id = 1890
// module chunks = 0